import viewReducers from './view-slice';

export default {
  ...viewReducers,
};

export * from './view-slice';
